import BlogCard from './BlogCard';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';
import { queryCategoryItems } from '../../common/blog-api/queryCategoryItems';
import BlogTimer from '../../common/blog-timer';
import { getBlogTagFromList } from '../../common/utils';
import EcoLink from 'eco-design/base/eco-link';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import 'swiper/scss';
import 'swiper/scss/navigation';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { categoryId, categoryName, items = [] } = data;
    const { locale = 'us' } = useRouter();
    const categoryHref = `/${locale}/blog/category/${categoryId}`;
    const [categoryNameA, setCategoryNameA] = useState(categoryName);
    const items2 = items.slice(0, 10);
    const [itemsA, setItemsA] = useState(items2);
    const prevRef = useRef<HTMLButtonElement>(null);
    const nextRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const getItemsForNone = async () => {
            const dataA = await queryCategoryItems(locale, {
                categoryId: categoryId,
            });
            setCategoryNameA(dataA?.categoryName);
            const itemsB2 = (dataA.items || []).slice(0, 10);
            setItemsA(itemsB2);
        };
        if (items2.length === 0 && categoryId) {
            getItemsForNone();
        }
    }, [categoryId, items2.length]);

    const showNav = itemsA.length > 1;

    return (
        <GloLayout className="editor-blog-category-a" id={id}>
            <div className="editor-blog-category-a-h">
                <div className="editor-blog-category-a-h-l">{categoryNameA}</div>
                {showNav && (
                    <div className="editor-blog-category-a-h-nav">
                        <button ref={prevRef} type="button" className="editor-blog-category-a-nav-prev swiper-button-prev" aria-label="Previous">
                            <EcoIconSwiperArrow className="editor-blog-category-a-nav-icon" />
                        </button>
                        <button ref={nextRef} type="button" className="editor-blog-category-a-nav-next swiper-button-next" aria-label="Next">
                            <EcoIconSwiperArrow className="editor-blog-category-a-nav-icon" />
                        </button>
                    </div>
                )}
            </div>
            <div className="editor-blog-category-a-c-wrapper">
                <Swiper
                    className="editor-blog-category-a-c"
                    modules={showNav ? [Navigation] : []}
                    navigation={
                        showNav
                            ? {
                                  prevEl: prevRef.current,
                                  nextEl: nextRef.current,
                              }
                            : undefined
                    }
                    onBeforeInit={(swiper: SwiperType) => {
                        const navigation = swiper.params.navigation;
                        if (!showNav || !navigation || typeof navigation === 'boolean') return;
                        navigation.prevEl = prevRef.current;
                        navigation.nextEl = nextRef.current;
                    }}
                    spaceBetween={24}
                    slidesPerView={1}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    }}
                >
                    {itemsA?.map((item: any, index: number) => {
                        const thePage = JSON.parse(item.thePage || '{}');
                        const tagItem = getBlogTagFromList(item.blogTagList || [], categoryId);
                        return (
                            <SwiperSlide key={index}>
                                <BlogCard
                                    label={tagItem.tag}
                                    title={thePage.blogTitle}
                                    pc={thePage.blogImgPc}
                                    h5={thePage.blogImgH5}
                                    href={item.seoUrl}
                                    categoryHref={`/${locale}/blog/category/${categoryId}`}
                                    timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            <div className="editor-blog-category-a-right">
                {itemsA.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], categoryId);
                    const postHref = item.href || item.seoUrl;
                    const postCategoryHref = item.categoryHref || categoryHref;
                    const dataLayer = {
                        event: 'uaEvent',
                        event_name: 'select_news',
                        title_name: thePage?.blogTitle || '',
                        button_name: thePage?.blogTitle || '',
                        url: postHref,
                        __btn_id1: `editor-blog-category-a-right-item-${index + 1}`,
                        __btn_id2: postHref,
                        __btn_type: 'blog_category_card',
                    };
                    return (
                        <div key={index} className="editor-blog-category-a-right-item">
                            <EcoLink href={postHref} dataLayer={dataLayer} target="_blank" className="editor-blog-category-a-img">
                                <EcoImgVideo isVideo={item.isVideo} pc={thePage.blogImgPc} h5={thePage.blogImgH5} />
                            </EcoLink>
                            <div className="editor-blog-category-a-msg">
                                <EcoLink href={postCategoryHref} target="_blank" className="editor-blog-category-a-label">
                                    {tagItem.tag}
                                </EcoLink>
                                <EcoLink href={postHref} dataLayer={dataLayer} target="_blank" className="editor-blog-category-a-title">
                                    {thePage.blogTitle}
                                </EcoLink>
                            </div>
                        </div>
                    );
                })}
            </div>
        </GloLayout>
    );
}
